<template>
  <div id="app">
    <!-- <HomeView/> -->
    <router-view/>
  </div>
</template>
<script>
// import { RouterView } from 'vue-router';
// import HomeView from './components/HomeView.vue'

export default {
  name: 'App',
  components: {
    // HomeView
  }
}
</script>

<style>
html,body{margin: 0 auto;padding: 0;font-size: 30px;}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>
